import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const PayrollRunsListPage = lazy(() => import('@pages/payroll/PayrollRunsListPage'));
const PayrollRunDetailPage = lazy(() => import('@pages/payroll/PayrollRunDetailPage'));

const PayrollRunsListRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('payroll-runs-title')}>
        <PayrollRunsListPage />
      </PageWrapper>
    </Suspense>
  );
};

const PayrollRunDetailRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('payroll-run-detail-title')}>
        <PayrollRunDetailPage />
      </PageWrapper>
    </Suspense>
  );
};

export default {
  PayrollRunsListRoute,
  PayrollRunDetailRoute,
};
